export const blockIconsTransportationDirectionsBikeNew = (
	<span className='material-symbols-outlined'>directions_bike</span>
);
